import { AnyAction, Middleware } from 'redux';
import { find } from 'lodash';
import { AGREEMENT, AGREEMENT_OBJECT } from 'core/datasets/action';
import { AppState } from 'core/redux/rootReducer';
import { selectedObjectIDSelector } from 'agreementObject/redux/agreementObjectsReducer';
import { InceptionUnit } from '../../types/inception';
import { inceptionActions } from '../inceptionActionCreators';
import { agreementSelectors } from 'agreement/redux/agreementsReducer';

const inceptionMiddleWare: Middleware =
    ({ getState, dispatch }) =>
    (next) => {
        return (action: AnyAction) => {
            next(action);

            switch (action.type) {
                case AGREEMENT.AGREEMENT_SELECTED:
                case AGREEMENT.DATA_UPDATED:
                case AGREEMENT_OBJECT.AGREEMENT_OBJECT_SELECTED: {
                    const state: AppState = getState();

                    const selectedAgreement = agreementSelectors.selectedAgreement(state);
                    const selectedObjectId = selectedObjectIDSelector(state);
                    let smartHomeUnits: InceptionUnit[] | null = null;

                    if (selectedAgreement) {
                        const agreementObject = find(selectedAgreement.objects, ['id', selectedObjectId]);

                        if (agreementObject) {
                            smartHomeUnits = selectedAgreement.smartHomeUnits || null;
                        }
                    }

                    dispatch(inceptionActions.unitsFetched(smartHomeUnits ? smartHomeUnits : []));
                    break;
                }
                default:
                    break;
            }
        };
    };

export default inceptionMiddleWare;
